<template>
    <div class="m-2 py-2 px-2 w-1/2 flex flex-row items-center bg-gradient-to-r from-purple-300 to-fuchsia-300 rounded-lg font-semibold text-purple-700 text-lg shadow-lg shadow-purple-200 border-2 border-purple-500 hover:bg-fuchsia-500 hover:shadow-2xl transition-all duration-300 ring-offset-2 focus:ring-2 focus:ring-fuchsia-400">
        <input class="mr-2" type="checkbox" id="checkbox" :checked="isDone"  @click="done">
        <router-link :to="{ name: 'todo', params: { id: id }}" class="truncate">{{text}}</router-link> 
    </div>




</template>

<script>
import { db } from "@/firebaseConfig";

export default {
  name: 'ToDoItem',
  props: {
      text:String,
      id: String
  },
  data () {
    return {
        isDone:false
    }
  },
  mounted() {
    db.collection('todos')
      .doc(this.id)
      .get()
      .then(snapshot => {
        this.isDone = snapshot.data().doneBool;
      });
  },
  methods: {
    done() {
        db.collection('todos').doc(this.id).update({
            doneBool: !this.isDone
        });
        
    }
  }
}
</script>

<style scoped>

</style>